import { parseKretzPesoBarcode } from './parsers/KretzPesoParser';

/**
 * Parsers registrados en orden de prioridad.
 * Futuro: KretzPrecioParser, SystelParser, ToledoParser, parser configurable.
 */
const SCALE_PARSERS = [
  parseKretzPesoBarcode
];

/**
 * Motor universal de etiquetas de balanza.
 * Devuelve null si el código no corresponde a ningún formato soportado.
 */
export function parseScaleBarcode(rawCode) {
  for (const parser of SCALE_PARSERS) {
    const parsed = parser(rawCode);
    if (parsed) return parsed;
  }
  return null;
}

export function isScaleBarcode(rawCode) {
  return parseScaleBarcode(rawCode) != null;
}

export { SCALE_PARSERS };
